

export class Constants {
    public static readonly emailUrl = 'mailto://TheRestInMotion@gmail.com';
}